import React, { useEffect, useRef, useState } from "react";
import DataHandler from "../../../utils/DataHandler";
import axios from "axios";
import F from "../../../Functions";
import { Translate } from "react-translated";
import DeactivateReviewSchedulerModal from "../../../components/deativate-review-scheduler";
import { Input, Button, Card, Spin, Modal, Checkbox, Icon, Select, Tag, message } from "antd";
import Pagination from "../../../components/pagination";


import DeleteRSUserModal from '../parts/delete-rs-user-modal'
import UnlinkUserModal from "../parts/unlink-user-modal";


// css 
import '../../../Common-Table/CustomAgGridTable.css';


// assets
import RefreshIcon from "../../../assets/refresh-icon.png";
import { withRouter } from "react-router-dom";
import CustomAgGridTable from "../../../Common-Table/CustomAgGridTable";
import ActionButtonRenderer from "./ActionButtonRenderer";
import { debounceQuery, getFullUserType, rolesFilter, TYPE_OF_CALL, USER_TYPE_DROPDOWN } from "../../../utils/Constants";
import ActivatedAgencyModal from "../../SuperAdmin/Modals/ActivatedAgencyModal/ActivatedAgencyModal";
import { CHECK_BEFORE_DEACTIVATE_API, GET_ROLES_API, GET_RS_USERS_API, RS_ALL_AGENCIES_API_URL } from "../../../utils/Api_enums";
import CustomHeader from "../../../CommonHeader/CustomHeader";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const { Search } = Input;
const {Option} = Select;

export const BUTTON_CONSTANTS = {
  deActivated: { label: "Deactivate", key: "de_activate" },
  agencies: { label: "Agencies", key: "agencies" },
};

const ActivatedSchedulers = (props) => {
  const debounceRef = useRef(null);




  const [activatedSchedulerState, setActivatedSchedulerState] = useState({
    loading: true,
    users: [],
    page: 1,
    total_pages: 0,
    user: {},
    agencies_modal: false,
    agencies_modal_loading: false,
    agencies: [],
    user_agencies: [],
    search: "",
    show_deactivate_rs_modal: false,
    rs_users: [],
    tableData: [],
    delete_rs_user_modal: false,
    unlink_user_modal: false,
    loggedin: props.auth.user,
  });
  const [selectedUserType, setSelectedUserType] = useState([]);
  const [roles, setRoles] = useState([]);
  const [sortOrders, setSortOrders] = useState({});

  // state for localefield
  const [localField, setLocalField] = useState("updated_on");
  // state for localorder
  const [localOrder, setLocalOrder] = useState("desc")

  // const [colDef, setColDef] = useState()

  

  const handleSort = (field) => {
    let newOrder;
    setSortOrders((prev) => {
        const currentOrder = prev[field] || "asc";
         newOrder = currentOrder === "asc" ? "desc" : "asc";
        return { ...prev, [field]: newOrder };
    });
    setLocalOrder(newOrder);
    setLocalField(field);
    // loadUsers()
};


   /**
   * 
   * @param {*} userData 
   * @returns void
   *  function check status before deactivate and open modal 
   *  if Existing scheduler has no agencies/bfiles associated.
   *  Hence could be deactivated
   */
const checkStatusBeforeDeactivate = async (userData) => {
  try {
    const { data } = await axios.get(
      `${CHECK_BEFORE_DEACTIVATE_API}/${userData.user.id}`
    );
    // check if Existing scheduler has no agencies/bfiles associated. Hence could be deactivated
    if (data.deactivate) {
      setActivatedSchedulerState((prevState) => ({
        ...prevState,
        show_deactivate_rs_modal: true,
        user: userData.user,
      }));
    } else if (data.deactivate === false) {
      message.error(F.translate(data.message));
      return;
    }
  } catch (error) {
    console.log(error);
  }
};


  

  const handleButtonClick =  (buttonType, data) => {
    // console.log("buttonType", buttonType, data);
    if (buttonType === BUTTON_CONSTANTS.deActivated.key) {
      // function check status before deactivate a
       checkStatusBeforeDeactivate(data);
      // setActivatedSchedulerState((prevState) => ({
      //   ...prevState,
      //   show_deactivate_rs_modal: true,
      //   user: data.user,
      // }));
      // get_all_active_rs_except_deactivated_user();
    } else if (buttonType === BUTTON_CONSTANTS.agencies.key) {
      setActivatedSchedulerState((prevState) => ({
        ...prevState,
        agencies_modal: true,
        user: data.user,
      }));
      loadUserAgencies(data.user.id);
    }
  };

  const getTypeOFCall = (user) => {
    const roles = user.roles;
      if(roles.length > 0) {
        const updatedRoles = roles.map((role) =>  TYPE_OF_CALL[role.rolename]);
        // console.log("updatedRoles",updatedRoles)
        return updatedRoles.join(",")
    }
     return ""
    }

    const CustomTooltip = (props) => {
      return (
          <div style={{
              background: "rgba(0, 0, 0, 0.8)",
              color: "white",
              padding: "8px 12px",
              borderRadius: "4px",
              fontSize: "12px",
              maxWidth: "200px",
              textAlign: "center"
          }}>
              {props.value}
          </div>
      );
  };

  const coleDef = [
    {
      headerClass: 'custom-ag-header',
      headerComponent: CustomHeader,
      tooltipComponent: CustomTooltip,
      headerName: "First Name",
      valueGetter: (params) => `${params.data.first_name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["first_name"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["First Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "first_name",
        sortOrder: sortOrders["first_name"],
        handleSort
    }),
    colId: 'first_name',
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Last Name",
      valueGetter: (params) => `${params.data.last_name || ""}`,
      sortable: true,
      // filter: true,
      sortOrder: sortOrders["last_name"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Last Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "last_name",
        sortOrder: sortOrders["last_name"],
        handleSort
    }),
    colId: 'last_name',
    headerComponent: CustomHeader,
    tooltipComponent: CustomTooltip,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Email",
      field: "email",
      sortable: true,
      // filter: true,
      width: 300,
      sortOrder: sortOrders["last_name"],
      // handleSort,
      headerComponentParams: (params) => ({
        headers: ["Email"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "email",
        sortOrder: sortOrders["email"],
        handleSort
    }),
    colId: 'email',
    headerComponent: CustomHeader,
    tooltipComponent: CustomTooltip,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "User Type",
      field: "user_type",
      sortable: true,
      filter: true,

      cellRendererFramework: (params) => {
        const userType = params.value;
        let displayUserType = params.value;

        if (userType === "REVIEWSCHEDULER") {
          displayUserType = "RS";
        } else if (userType === "LSP") {
          displayUserType = "LSP";
        }else if(userType === "VONBOARDER"){
          displayUserType="FS";
        }else if(userType === "VONSCHEDULER"){
          displayUserType="RFS";
        }

        return (
          <div>
            <span
              style={{
                backgroundColor: "rgba(22, 72, 151, 0.12)",
                color: "#000",
                padding: "5px 5px",
                borderRadius: "7px",
              }}
            >
              {/* {params.value} */}
              {displayUserType}
            </span>
          </div>
        );
      },
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Type of Call",
      field: "type_of_Call",
      sortable: true,
      filter: true,
    },

    {
      headerClass: 'custom-ag-header',
      headerName: "Actions",
      cellRendererFramework: ActionButtonRenderer,
      width: 300,
      // cellRendererParams: {
      //   onButtonClick: (buttonType, data) =>
      //     handleButtonClick(buttonType, data),
      // },
      cellRendererParams: {
        onButtonClick: (buttonType, data) =>
          handleButtonClick(buttonType, data), // Pass as callback
        activatedSchedulerState,
      },
    },
  ];

  useEffect(() => {
    loadagency();
    return () => DataHandler.setReviewSchedulerListCallback(null);
  }, []);


  useEffect(()=>{
    const getRoles = async()=>{
        const {data:{roles}} = await axios.get(GET_ROLES_API);
        setRoles(roles.map(item=>{
            return {
                label: TYPE_OF_CALL[item.rolename], 
                value: TYPE_OF_CALL[item.rolename], 
                role_id: item.role_id,
                // checked:false, 
            }
        }))
    }
    getRoles();
},[])

  useEffect(() => {
    if (
      activatedSchedulerState.user &&
      activatedSchedulerState.show_deactivate_rs_modal
    ) {
      get_all_active_rs_except_deactivated_user();
    }
  }, [activatedSchedulerState.user]);

  useEffect(() => {
    loadUsers(activatedSchedulerState.page);  // Call loadUsers with the current page
  }, [localField, localOrder]); 

  // useEffect to trigger the debounced function when `search` state changes
  useEffect(() => {
    if (activatedSchedulerState.search !== "") {
      clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        debounceQuery(() => loadUsers(1), 500);
      }, 500);
    } else {
      loadUsers(1);
    }
    return () => {
      clearTimeout(debounceRef.current);
    };
  }, [activatedSchedulerState.search, selectedUserType]);


  

  const refreshInfo = () => {
    setActivatedSchedulerState((prevState) => ({
      ...prevState,
      search: "",
    }));
    setSelectedUserType([])
    loadUsers(activatedSchedulerState.page);
  };

  const searchUser = (value) => {
    //   this.setState({ search: event.target.value }, () => {
    //     debounceQuery(this.loadUsers.bind(this, 1));
    //   });
    setActivatedSchedulerState((prevState) => ({
      ...prevState,
      search: value,
    }));
    // setActivatedScheduler({searchName:value})



    // debounceQuery(() => loadUsers(1), 500);
  };

  const loadagency = () => {
    loadUsers(1);
    // set Review Scheduler List Callback to update
    DataHandler.setReviewSchedulerListCallback(loadUsers);
    setActivatedSchedulerState((prevState) => ({
      ...prevState,
      loading: true
    }));
    // axios.get("/api/rs_all_agencies").then((res) => {
    axios.get(RS_ALL_AGENCIES_API_URL).then((res) => {
      //   this.setState({
      //     agencies: res.data
      //   });
      setActivatedSchedulerState((prevState) => ({
        ...prevState,
        agencies: res.data,
      }))
    }).catch((err) => {
      console.log(err);
    }).finally(() => {
      setActivatedSchedulerState((prevState) => ({
        ...prevState,
        loading: false
      }))
    });

  };

  const loadUsers = async (page) => {
    // const filters = [ { "name": "active", "op": "==", "val": 1 },
    //   {
    //     "or": [
    //       { "name": "user_type", "op": "==", "val": "VONBOARDER" },
    //       { "name": "user_type", "op": "==", "val": "REVIEWSCHEDULER" },
    //       { "name": "user_type", "op": "==", "val": "VONSCHEDULER" }
    //     ]
    //   },
    //   {
    //     "or": [
    //       {
    //         "and": [
    //           {
    //             "name": "roles",
    //             "op": "any",
    //             "val": { "name": "role_id", "op": "==", "val": 3 }
    //           }
    //         ]
    //       }
    //     ]
    //   }];
    const filters = [];
    filters.push({
      name: "active", 
      op: "==", 
      val: 1
    },
    {
      or: [
        { name: "user_type", op: "==", val: "VONBOARDER" },
        { name: "user_type", op: "==", val: "REVIEWSCHEDULER" },
        { name: "user_type", op: "==", val: "VONSCHEDULER" }
      ]
}
  );

    // Dynamically add filters to the array
   if(selectedUserType.length>0){

    // selectedUserType.forEach((userType) => {
    //     filters.push({
    //       name: "user_type",
    //       op: "==",
    //       val: getFullUserType(userType)
    //     });
    //   });

      let or = await rolesFilter(roles,selectedUserType)
        filters.push({
          or: or,
        });
     
   }
    const searchPurify = F.removeSpecialCharactersFromString(
      activatedSchedulerState.search
    );



  let orderBy =  {
        "field": localField,
        "direction": localOrder
    }
      


  // filters.push(orderBy);


    if (searchPurify.trim().length > 0) {
      filters.push({
        or: [
          {
            name: "first_name",
            op: "like",
            val: encodeURIComponent("%" + searchPurify + "%"),
          },
          {
            name: "last_name",
            op: "like",
            val: encodeURIComponent("%" + searchPurify + "%"),
          },
          {
            name: "email",
            op: "like",
            val: encodeURIComponent("%" + searchPurify + "%"),
          },
        ],
      });
    }

    const nPage = page === undefined ? 1 : page;

    const api =
      "/api/users?page=" +
      nPage +
      '&q={"filters":' +
      JSON.stringify(filters) +
      ',"order_by":' +JSON.stringify([orderBy]) +
      "}";
    // this.setState({ loading: true });
    setActivatedSchedulerState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    axios.get(api).then((res) => {
      //   this.setState({
      //     loading: false,
      //     users: res.data.objects,
      //     page: res.data.page,
      //     total_pages: res.data.total_pages
      //   });
      const users = res.data.objects;
      const data = [];
      for (let i = 0; i < users.length; i++) {
        let user = users[i];
        data.push({
          key: i,
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          phone: user.phone,
          user_type: user.user_type,
          type_of_Call: getTypeOFCall(user),
          user: user,
        });
      }

      setActivatedSchedulerState((prevState) => ({
        ...prevState,
        loading: false,
        users: users,
        page: res.data.page,
        total_pages: res.data.total_pages,
        tableData: data,
      }));
    }).catch((err) => {
      console.log(err);
    }).finally(() => {
      setActivatedSchedulerState((prevState) => ({
        ...prevState,
        loading: false,
      }));
    });
  };

  // calling the api to get list of rs users 
  const get_all_active_rs_except_deactivated_user = () => {
    const { user } = activatedSchedulerState;
    // axios.get("/api/rs_active_users/" + user.id).then((res) => {
    axios.get(GET_RS_USERS_API).then((res) => {
      //   this.setState({
      //     // agencies: res.data,
      //     rs_users: res.data
      //   });
      setActivatedSchedulerState((prevState) => ({
        ...prevState,
        rs_users: res.data,
      }));
    });
  };

  const loadUserAgencies = (user_id) => {
    // this.setState({
    //   agencies_modal_loading: true
    // });
    setActivatedSchedulerState((prevState) => ({
      ...prevState,
      agencies_modal_loading: true,
    }));

    axios.get("/api/rs_agencies_assoc/" + user_id).then((res) => {
      var agencies = [];
      for (let i = 0; i < res.data.length; i++) {
        const agency = res.data[i];
        agencies.push(agency.agency_id);
      }
      //   this.setState({
      //     agencies_modal_loading: false,
      //     user_agencies: agencies
      //   });
      setActivatedSchedulerState((prevState) => ({
        ...prevState,
        agencies_modal_loading: false,
        user_agencies: agencies,
      }));
      // console.log("hooks agencies", agencies);

    });
  };

  const updateAgencyAssoc = (agency_id, checked) => {
    // this.setState({
    //   agencies_modal_loading: true
    // });
    setActivatedSchedulerState((prevState) => ({
      ...prevState,
      agencies_modal_loading: true,
    }));
    var val = 0;
    if (checked) val = 1;
    axios
      .post(
        "/api/update_rs_agency_assoc/" +
          activatedSchedulerState.user.id +
          "/" +
          agency_id +
          "/" +
          val
      )
      .then(() => {
        loadUserAgencies(activatedSchedulerState.user.id);
      }).finally(() => {
        setActivatedSchedulerState((prevState) => ({
          ...prevState,
          agencies_modal_loading: false,
        }));
      });
  };

  const handleCloseModal = ()=>{
    setActivatedSchedulerState((prevState) => ({
      ...prevState,
      agencies_modal: false,
    }));
  }


  
  const customTagRender = (props) => {
    const { label, value, closable, onClose } = props;
    return (
      <Tag closable={closable} onClose={onClose}>
        {value}
      </Tag>
    );
  };

  return (
    <div className="table-container">
      {/* Manage Schedulers header  */}
      <div className="manage-scheduler-header-container">
        <div><h5>Activated Schedulers</h5></div>
        <div>
          <Search
            value={activatedSchedulerState.search}
            placeholder=" search by name "
            onSearch={(value) => searchUser(value)}
            onChange={(e) => {
              searchUser(e.target.value);
            }}
            style={{ width: 200 }}
            className="searchinput"
          />
          <Select
            value={selectedUserType}
            // allowClear
            mode="multiple"
            placeholder=" search user Type "
            onChange={(value) => {
              // setActivatedScheduler({userType: value})
              setSelectedUserType(value);
            }}
            style={{
              width: 200,
              backgroundColor: "#fff",
              borderRadius: "20px",
              border: "1px solid #cfc9c9",
            }}
            className="searchinput user_type_select"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            tagRender={customTagRender}
            optionLabelProp="value"
          >
            {roles.map((option) => (
              <Option key={option.role_id} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
          {/* <Button
            style={{
              background: "#164897",
              borderRadius: "10px",
              width: "10%",
            }}
            onClick={refreshInfo}
          >
            <img src={RefreshIcon} alt="Refresh" />
          </Button> */}

          <Button
            style={{
              marginTop: "0px",
            }}
            type="primary"
            className="refresh-con"
            onClick={refreshInfo}
          >
            <Icon type="reload" />
          </Button>
        </div>
      </div>

      {/* Manage Schedulers Table  */}
      <div style={{margin:"10px 0px 0px 0px"}}>
        {coleDef.length > 0 &&
        Array.isArray(activatedSchedulerState.tableData) ? (
          <Spin spinning={activatedSchedulerState.loading}>
            <CustomAgGridTable
              rowDatas={activatedSchedulerState.tableData}
              columnDefss={coleDef}
              styles={{ height: "400px", minHeight: "380px" }}
            />
          </Spin>
        ) : (
          <p className="Loader-container">
            <Spin size="large" />
          </p>
        )}
      </div>
      <div style={{ marginTop: "10px" }}>
        <Pagination
          // style={{ padding: "5px 0px" }}
          className="pagination-container"
          current_page={activatedSchedulerState.page}
          total_pages={activatedSchedulerState.total_pages}
          onClick={(page) => {
            loadUsers(page);
          }}
        />
      </div>

      <div>
        {/* {activatedSchedulerState.agencies_modal ? (
          <Modal
            title={<Translate text={`Agencies`} />}
            visible={activatedSchedulerState.agencies_modal}
            onCancel={() => {
              // this.setState({ agencies_modal: false })
              setActivatedSchedulerState((prevState) => ({
                ...prevState,
                agencies_modal: false,
              }));
            }}
            footer={
              <div>
                <Button
                  onClick={() => {
                    // this.setState({ agencies_modal: false })
                    setActivatedSchedulerState((prevState) => ({
                      ...prevState,
                      agencies_modal: false,
                    }));
                  }}
                >
                  <Translate text={`Cancel`} />
                </Button>
              </div>
            }
          >
            <Spin
              indicator={antIcon}
              spinning={activatedSchedulerState.agencies_modal_loading}
            >
              <div className="formBox">
                {activatedSchedulerState.agencies.map((agency, i) => (
                  <div key={i}>
                    <Checkbox
                      checked={
                        activatedSchedulerState.user_agencies.indexOf(
                          agency.id
                        ) >= 0
                      }
                      onChange={(e) => {
                        updateAgencyAssoc(agency.id, e.target.checked);
                      }}
                    >
                      {agency.name}
                    </Checkbox>
                  </div>
                ))}
              </div>
            </Spin>
          </Modal>
        ) : null} */}
      </div>

      <div>
        {/** Deactivate Review Scheduler Modal */}
        {activatedSchedulerState.show_deactivate_rs_modal ? (
          <DeactivateReviewSchedulerModal
            // history={this.props.history}
            showModal={activatedSchedulerState.show_deactivate_rs_modal}
            hideModal={() =>
              // this.setState({ show_deactivate_rs_modal: false })
              setActivatedSchedulerState((prevState) => ({
                ...prevState,
                show_deactivate_rs_modal: false,
              }))
            }
            deactivatedUser={activatedSchedulerState.user}
            rs_users={activatedSchedulerState.rs_users}
            // agency_id={this.state.agency_id_von}
          />
        ) : null}
      </div>

      {/* new Agency Modal Component */}
      {activatedSchedulerState.agencies_modal && (
        <ActivatedAgencyModal
          isVisible={activatedSchedulerState.agencies_modal}
          closeModal={handleCloseModal}
          agencies={activatedSchedulerState.agencies}
          user={activatedSchedulerState.user}
          title={<Translate text={`Agencies`} />}
          // parentInstance={parentInstance}
          setActivatedSchedulerState={setActivatedSchedulerState}
          activatedSchedulerState={activatedSchedulerState}
          user_agencies={activatedSchedulerState.user_agencies}
          updateAgencyAssoc={updateAgencyAssoc}
        />
      )}


        {/* Deleteuser Modal */}
            {activatedSchedulerState.delete_rs_user_modal ? (
              <DeleteRSUserModal
                history={props.history}
                showModal={activatedSchedulerState.delete_rs_user_modal}
                hideModal={() =>
                  setActivatedSchedulerState((prevState) => ({
                    ...prevState,
                    delete_rs_user_modal: false,
                  }))
                }
                user={activatedSchedulerState.user}
                refresh={() => loadUsers(1)}
                loggedin={activatedSchedulerState.loggedin}
              />
            ) : null}
      
      
      
            {/* unlink user modal */}
      
            <UnlinkUserModal
                history={props.history}
                showModal={activatedSchedulerState.unlink_user_modal}
                hideModal={() => setActivatedSchedulerState((prevState) => ({
                  ...prevState,
                  unlink_user_modal: false,
                }))}
                user={activatedSchedulerState.user}
                refresh={() => loadUsers(1)}
                loggedin={activatedSchedulerState.loggedin}
              />
      
    </div>
  );
};

export default ActivatedSchedulers;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/ActivatedSchedulers/ActivatedSchedulers.js